/* eslint-disable react/jsx-props-no-spreading */
import React from "react";

import WithdrawalBannerContent from "@/components/molecules/withdrawal-verification-section/withdrawal-header-banner/withdrawal-banner-content";
import WithdrawalImageContent from "@/components/molecules/withdrawal-verification-section/withdrawal-header-banner/withdrawal-image-content";

interface WithdrawalBannerProps {
  withdrawalBannerTitle: string;
  withdrawalBannerDescription: string;
  withdrawalBannerImage: {
    "@name": string;
    "@path": string;
    "@id": string;
    "@link": string;
    "@type": string;
    "@uuid": string;
  } | null;
}

function WithdrawalHeaderBanner({ ...props }: Readonly<WithdrawalBannerProps>) {
  return (
    <div
      className="grid lg:grid-cols-12 lg:col-span-12 lg:order-1 gap-spacing-m md:gap-spacing-l"
      data-testid="withdrawal-headerBanner-testid"
    >
      <div className="relative overflow-hidden h-[88px] md:h-[120px] lg:h-full rounded-radius-xxl lg:col-span-5 lg:order-2">
        <WithdrawalImageContent {...props} />
      </div>
      <div className="bg-dark-surface-accent-1-primary text-text-body lg:text-dark-text-title rounded-radius-xxl p-spacing-l md:p-spacing-xl font-body-font lg:col-span-7 lg:order-1">
        <WithdrawalBannerContent {...props} />
      </div>
    </div>
  );
}

export default WithdrawalHeaderBanner;
